// @flow

import React, { PureComponent } from 'react';
import debounce from 'lodash.debounce';
import { graphql, QueryRenderer } from 'react-relay';
import { i18n } from 'shared/utils';
import relayEnvironment from 'shared/gql/relayEnvironment';
import Loader from 'shared/components/common/Loader';
import Page from 'main-app/components/Page';
import PageHeaderList from 'main-app/components/PageHeaderList';
import AddUpdateWarehouseLocationModal from 'main-app/components/AddUpdateWarehouseLocationModal';
import type { RouterHistory } from 'react-router';
import PaginatedWarehouseLocationsContainer from './PaginatedWarehouseLocationsContainer';

type Props = {
  history: RouterHistory,
};

type State = {
  addModalOpen: boolean,
  search: string,
  graphqlSearchValue: string,
};

class WarehouseLocations extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      addModalOpen: false,
      search: '',
      graphqlSearchValue: '',
    };

    this.handleDebouncedSearch = debounce(this.handleDebouncedSearch, 500);
  }

  handleSearchInput = (search: string) => {
    this.setState({ search }, this.handleDebouncedSearch);
  };

  handleDebouncedSearch = () => {
    const { search } = this.state;
    this.setState({ graphqlSearchValue: search });
  };

  handleOpenCreateModal = () => {
    this.setState({ addModalOpen: true });
  };

  handleCloseModal = () => {
    this.setState({ addModalOpen: false });
  };

  render() {
    const { search, addModalOpen, graphqlSearchValue } = this.state;

    return (
      <QueryRenderer
        environment={relayEnvironment}
        cacheConfig={{ force: true }}
        query={graphql`
          query WarehouseLocationsQuery(
            $count: Int!
            $search: String
            $cursor: String
          ) {
            ...PaginatedWarehouseLocationsContainer_data
              @arguments(search: $search)
            viewer {
              id
              permissions
            }
          }
        `}
        variables={{
          count: 30,
          cursor: null,
          search: graphqlSearchValue.trim() || null,
        }}
        render={({ props }) => (
          <Page>
            <PageHeaderList
              title={i18n.t('Warehouse Locations')}
              createButtonLabel={props && i18n.t('New Location')}
              onCreateButtonClick={this.handleOpenCreateModal}
              searchPlaceholder={i18n.t('Search locations...')}
              searchValue={search}
              onSearchChange={this.handleSearchInput}
            />
            {!props ? (
              <Loader />
            ) : (
              <PaginatedWarehouseLocationsContainer
                data={props}
                filtersDirty={!!graphqlSearchValue}
                onCreateNew={this.handleOpenCreateModal}
              />
            )}
            {addModalOpen && (
              <AddUpdateWarehouseLocationModal
                onClose={this.handleCloseModal}
                location={null}
              />
            )}
          </Page>
        )}
      />
    );
  }
}

export default WarehouseLocations;
